import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Formik, Field } from "formik";
import { Input, Row, Col } from "antd";
import { FormInputField } from "../../../../Components/FormInputField/FormInputField";

function Profile({
  currentUser,
  updatePhone,
  updateAddress,
  toggleUpdateDisability,
}) {
  const originalPhone = currentUser.data.phone;
  const originalAddress = currentUser.data.address;
  const [phone, setPhone] = useState(currentUser.data.phone);
  const [address, setAddress] = useState(currentUser.data.address);
  const [circles, setCircles] = useState(null);
  const [zones, setZones] = useState(null);
  const [districts, setDistricts] = useState(null);
  const [phoneError, setPhoneError] = useState(null);
  const [addressError, setAddressError] = useState(null);
  useEffect(() => {
    let zonesString = "";
    currentUser?.data?.zones.map((zone, i, { length }) => {
      zonesString = zonesString.concat(zone.name);
      if (i + 1 !== length) {
        zonesString.concat(", ");
      }
    });
    setZones(zonesString);

    let circlesString = "";
    currentUser?.data?.circles.map((circle, i, { length }) => {
      circlesString = circlesString.concat(circle.name);
      if (i + 1 !== length) {
        circlesString = circlesString.concat(", ");
      }
    });
    setCircles(circlesString);

    let districtsString = "";
    currentUser?.data?.districts?.map((district, i, { length }) => {
      districtsString = districtsString.concat(district?.name);
      if (i + 1 !== length) {
        districtsString = districtsString?.concat(", ");
      }
    });
    setDistricts(districtsString);
  }, [districts, zones, circles]);

  useEffect(() => {
    toggleUpdateDisability(phoneError || addressError);
  }, [phoneError, addressError]);

  const onPhoneChanged = (e) => {
    let newPhone = e.target.value;
    if (
      newPhone === originalPhone &&
      originalPhone !== null &&
      originalPhone !== ""
    ) {
      setPhoneError(
        "The phone number you entered is the same as the previous one."
      );
    } else if (isNaN(newPhone) || newPhone.includes(".")) {
      setPhoneError("The phone number you entered is of incorrect format.");
    } else if (!(newPhone.length == 11 || newPhone.length == 0)) {
      setPhoneError("The phone number you entered is of incorrect length.");
    } else if (newPhone === "") {
      if (originalPhone !== "") {
        setPhoneError("New phone number cannot be empty.");
      } else {
        setPhoneError(null);
      }
    } else {
      setPhoneError(null);
    }
    setPhone(newPhone);
    updatePhone(newPhone);
  };
  const onAddressChanged = (e) => {
    let newAddress = e.target.value;
    if (
      newAddress === originalAddress &&
      originalAddress !== null &&
      originalAddress !== ""
    ) {
      setAddressError(
        "The address you entered is the same as the previous one."
      );
    } else if (newAddress === "") {
      if (originalAddress) {
        setAddressError("New address cannot be empty.");
      } else {
        setAddressError(null);
      }
    } else {
      setAddressError(null);
    }
    setAddress(newAddress);
    updateAddress(newAddress);
  };

  return (
    <>
      <Formik
        initialValues={{
          name: currentUser.data.full_name,
          email: currentUser.data.email,
          phone: phone,
          address: address,
          district: districts,
          zones: zones,
          circles: circles,
        }}
        enableReinitialize={true}
      >
        {(formikProps) => {
          return (
            <>
              <Row>
                <Col span={12} className="column-left">
                  <Field
                    InputType={Input}
                    component={FormInputField}
                    labelText="Name"
                    hideErrorMessage={true}
                    value={formikProps.values.name}
                    className="text-field"
                    disabled={true}
                    placeholder={"—"}
                  />
                </Col>
                <Col span={12} className="column-right">
                  <Field
                    InputType={Input}
                    component={FormInputField}
                    labelText="Email"
                    hideErrorMessage={true}
                    value={formikProps.values.email}
                    className="text-field"
                    disabled={true}
                    placeholder={"—"}
                  />
                </Col>
              </Row>
              <Row>
                <Col span={12} className="column-left">
                  <Field
                    InputType={Input}
                    component={FormInputField}
                    labelText="Phone"
                    hideErrorMessage={true}
                    value={formikProps.values.phone}
                    className="text-field"
                    disabled={false}
                    placeholder={"—"}
                    onChange={onPhoneChanged}
                    style={{ marginBottom: phoneError && "-20px" }}
                  />
                  {phoneError && (
                    <span style={{ color: "red", marginLeft: "5px" }}>
                      {phoneError}
                    </span>
                  )}
                </Col>
                <Col span={12} className="column-right">
                  <Field
                    InputType={Input}
                    component={FormInputField}
                    labelText="Address"
                    hideErrorMessage={true}
                    value={formikProps.values.address}
                    className="text-field"
                    disabled={false}
                    placeholder={"—"}
                    onChange={onAddressChanged}
                    style={{ marginBottom: addressError && "-20px" }}
                  />
                  {addressError && (
                    <span style={{ color: "red", marginLeft: "5px" }}>
                      {addressError}
                    </span>
                  )}
                </Col>
              </Row>
              <Row>
                <Col span={12} className="column-left">
                  <Field
                    InputType={Input}
                    component={FormInputField}
                    labelText="Districts"
                    hideErrorMessage={true}
                    value={formikProps.values.district}
                    className="text-field"
                    disabled={true}
                    placeholder={"—"}
                  />
                </Col>
                <Col span={12} className="column-right">
                  <Field
                    InputType={Input}
                    component={FormInputField}
                    labelText="Zones"
                    hideErrorMessage={true}
                    value={formikProps.values.zones}
                    className="text-field"
                    disabled={true}
                    placeholder={"—"}
                  />
                </Col>
              </Row>
              {currentUser.data.user_roles[0].role_id === 1 && (
                <Row>
                  <Col span={24}>
                    <Field
                      InputType={Input}
                      component={FormInputField}
                      labelText="Circles"
                      hideErrorMessage={true}
                      value={formikProps.values.circles}
                      className="text-field"
                      disabled={true}
                      placeholder={"—"}
                    />
                  </Col>
                </Row>
              )}
            </>
          );
        }}
      </Formik>
    </>
  );
}

const mapStateToProps = ({ user: { currentUser } }) => ({ currentUser });

Profile.propTypes = {
  currentUser: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(Profile);
